{
  "ui": {
    "feedback": "Feedback",
    "credits": "Credits",
    "currentMaintainer": "Current maintainer",
    "maintainerPeriod": "2026 onwards",
    "originalTeam": "Original team",
    "creditsCampaigns": "Jungle & Christmas",
    "moreSettings": "More settings",
    "chooseLanguage": "Choose your language",
    "notebookTools": "Notebook tools",
    "visualGuide": "Picture guide",
    "templeSoon": "Coming soon",
    "playAdventure": "Play",
    "story": "The story",
    "loadingAdventure": "Packing for the adventure…",
    "storyOpening": "A school trip into the jungle. Marco and Sophia explore with their friends. A colorful bird catches Marco’s eye, and he follows it into the trees. Suddenly he is alone. Help the explorers find their way!",
    "storyEnding": "Marco and Sophia reach the lost temple together. A mysterious face guards the entrance. A new adventure awaits!",
    "blockCategories": "Notebook tabs",
    "actions": "Actions",
    "loops": "Loops",
    "conditions": "Conditions",
    "title": "Run Marco! — An adventure in your notebook",
    "home": "Run Marco home",
    "map": "Adventure map",
    "worlds": "Choose an adventure",
    "notebook": "My notebook",
    "notebookToggle": "Open or close your notebook",
    "notebookOpen": "Open notebook",
    "notebookClose": "Watch the trail",
    "page": "Page {number}",
    "level": "Trail {number}",
    "run": "Let’s go!",
    "stop": "Stop",
    "step": "Step",
    "stepTitle": "Run one instruction",
    "reset": "Return to the start",
    "add": "Add",
    "addLabel": "Choose a block to add",
    "addHint": "Snap your blocks together, then press Play.",
    "undo": "Undo",
    "clear": "Fresh page",
    "hint": "A little hint",
    "help": "How to play",
    "settings": "Settings",
    "language": "Game language",
    "blockLanguage": "Block language",
    "blockLanguageNote": "You can choose a different language for the blocks.",
    "musicOn": "Turn on sound",
    "musicOff": "Turn off sound",
    "sound": "Music & sound effects",
    "speed": "Adventure speed",
    "chooseExplorer": "Choose your explorer",
    "explorer": "Explorer",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Close",
    "done": "Let’s explore",
    "loading": "Finding the trail…",
    "loadError": "The adventure could not load. Please reload to try again.",
    "imageError": "Some artwork could not load. Please reload the page.",
    "gemGoal": "Find the gem",
    "goal": "Find the golden star",
    "cover": "Light every tile, just once",
    "lit": "{count} / {total} tiles lit",
    "explored": "{count} / {total} trails explored",
    "facing": "Facing {direction} {arrow}",
    "boardLabel": "{name} on {level}, facing {direction}. {steps}. {objective}.",
    "up": "up",
    "down": "down",
    "left": "left",
    "right": "right",
    "steps_one": "{count} step",
    "steps_other": "{count} steps",
    "blocks_one": "{count} block",
    "blocks_other": "{count} blocks",
    "stars_one": "{count} star",
    "stars_other": "{count} stars",
    "place": "Add blocks",
    "atEnd": "At the end",
    "insideRepeat": "Inside repeat {number}",
    "insideIf": "Inside if {number}",
    "insideElse": "Inside else {number}",
    "readyFirst": "One small step. Add a forward block and let’s go!",
    "ready": "Where shall we go? Make a plan in your notebook.",
    "back": "Back at the start. Your blocks are ready to try again.",
    "empty": "Add a block to your notebook first.",
    "win": "You found your way!",
    "winCover": "You lit up the trail!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "What an adventure!",
    "simpler": "Can you do it with fewer blocks?",
    "complete": "Trail complete! Your best stars are saved.",
    "next": "Next trail",
    "allWorlds": "More adventures",
    "replay": "Play again",
    "shortGoal": "Almost! Add a few more blocks to reach the star.",
    "shortGem": "Almost! Add a few more blocks to reach the gem.",
    "shortCover": "Some tiles are still dark. How can we reach them?",
    "checking": "Looking at the trail…",
    "paused": "Stopped here. Play starts again from the beginning.",
    "going": "Off we go!",
    "stepped": "One step closer. Press Step again, or Play to continue.",
    "clueCover": "Start at an edge and trace the whole shape. A jump can skip a tile without lighting it.",
    "clueCondition": "Look at the trail ahead. A condition helps your explorer choose what to do.",
    "clueRepeat": "Which steps keep coming back? Put that pattern inside a repeat block.",
    "clueForward": "Forward is the way your explorer is facing. Count the tiles to the star.",
    "clueGem": "Forward is the way your explorer is facing. Count the tiles to the gem.",
    "clueTurn": "A turn changes direction without moving. Trace the trail with your finger.",
    "mapNote": "Pick a trail. Your best stars stay with you.",
    "mapLevel": "Trail {number}: {name}. {stars}.",
    "locked": "Finish the previous trail to unlock this one.",
    "soundBlocked": "Tap the sound button to hear the adventure.",
    "clearTitle": "Turn to a fresh page?",
    "clearNote": "This clears your blocks for this trail. Undo can bring them back.",
    "keep": "Keep my blocks",
    "clearConfirm": "Clear blocks",
    "fresh": "A fresh page. Where will your next plan take us?",
    "localProgress": "Your progress is saved on this device.",
    "helpBuild": "Make a plan",
    "helpBuildText": "Drag blocks onto your notebook and snap them together. You can also choose a block and tap Add. Choose “Inside repeat” to add steps to a loop.",
    "helpTurn": "Follow your explorer",
    "helpTurnText": "Forward follows the direction your explorer faces. Left and right turn without moving. Jump travels two tiles.",
    "helpTry": "Try, watch, try again",
    "helpTryText": "Press Play to try your plan or Step to follow one instruction at a time. The curved arrow returns you to the start and keeps your blocks.",
    "helpWorlds": "Every adventure has a goal",
    "helpWorldsText": "In Jungle, find the gem. In Christmas, light each open tile once. In Temple and Aegean, complete the repairs and visible goals, then reach the exit.",
    "noTrail": "No path there! Try turning before moving.",
    "broken": "That bridge is broken. Can you jump over it?",
    "blocked": "Something is in the way. Try a jump or another route.",
    "alreadyLit": "That tile is already lit. Visit each tile just once.",
    "loopError": "This plan keeps repeating. Try changing the loop.",
    "repeatError": "Choose a repeat count from 1 to 99.",
    "unsupported": "Remove the unsupported block and try again.",
    "connect": "Join your blocks into one chain, then press Play.",
    "path": "path",
    "backpack": "Backpack",
    "templeGems": "Temple gems",
    "gemsCollected": "Gems: {count} / {total}",
    "gemsReady": "All the gems are collected!",
    "aegeanTitle": "The Clockwork Aegean",
    "harbour": "Harbour",
    "aegeanDescription": "Explore the harbour: repair stations, reuse routines and pass a number with each work order.",
    "templeBetaNote": "Beta · Puzzles and lessons are being revised",
    "aegeanBetaNote": "Beta · First 3 harbour levels",
    "seasonal": "Seasonal adventure",
    "choosePreview": "Choose a preview level",
    "repairs": "Repairs",
    "reachExit": "Reach the exit",
    "taskRequirements": "Task requirements",
    "lessonGuided": "Guided practice · complete the supplied program",
    "lessonRepair": "Debugging · repair the supplied program",
    "lessonChallenge": "Challenge · build your own program",
    "acc_define_parameter": "Routine",
    "acc_call_argument": "Use routine",
    "acc_repeat_parameter": "Repeat using input",
    "parameter": "parameter",
    "argument": "send",
    "callInput": "This call’s input",
    "inputWaiting": "Run or Step to see the next input.",
    "argumentMismatch": "A routine with a parameter needs a call with a number. A routine without a parameter needs an ordinary call.",
    "unsetParameter": "Use a parameter only inside the routine that receives it. Parameters are separate from shared memory.",
    "memoryObjective": "Check the repair record and exit requirements. Any program that meets them is accepted.",
    "gate": "The way is blocked. Check the unfinished repairs.",
    "noPickup": "Stand on the tool before picking it up.",
    "creditLead": "Team lead & software engineering",
    "creditArt": "Illustration & scenery",
    "creditAnimation": "Animation",
    "creditUX": "UI & UX design",
    "creditDesign": "Game design",
    "creditStory": "Story writing",
    "creditAudio": "Music & sound engineering",
    "lightLamp": "Light lamp",
    "oilLamp": "Oil lamp",
    "dustyStation": "dusty station",
    "betaLabel": "Beta",
    "noLamp": "Stand on an unlit lamp before lighting it.",
    "collected": "Tool collected · ready to use",
    "dustyPrompt": "Stand on a dusty station before using the brush.",
    "lampMissing": "Collect the oil lamp first. Check your backpack.",
    "recursiveRoutine": "This routine calls itself. Use a different routine; recursive calls are not available yet."
  },
  "content": {
    "jungle.title": "Jungle expedition",
    "jungle.description": "Follow the trail to the lost temple.",
    "jungle-1": "First steps",
    "jungle-2": "A little further",
    "jungle-3": "Around the corner",
    "jungle-4": "Change direction",
    "jungle-5": "Follow the trail",
    "jungle-6": "A new route",
    "jungle-7": "Branching out",
    "jungle-8": "Jungle junction",
    "jungle-9": "Find your way",
    "jungle-10": "Think ahead",
    "jungle-11": "The long trail",
    "jungle-12": "A winding route",
    "jungle-13": "Leap of faith",
    "jungle-14": "Patterns appear",
    "jungle-15": "Repeat the rhythm",
    "jungle-16": "Choose a path",
    "jungle-17": "Look before you leap",
    "jungle-18": "Read the trail",
    "jungle-19": "A clever detour",
    "jungle-20": "Into the canopy",
    "jungle-21": "Bridge builder",
    "jungle-22": "Beyond the river",
    "jungle-23": "Explore the ruins",
    "jungle-24": "Stone and timber",
    "jungle-25": "A bigger jump",
    "jungle-26": "Follow the clues",
    "jungle-27": "Higher ground",
    "jungle-28": "Keep exploring",
    "jungle-29": "Twisting paths",
    "jungle-30": "The secret garden",
    "jungle-31": "Hidden patterns",
    "jungle-32": "Ancient pathways",
    "jungle-33": "The final turns",
    "jungle-34": "Temple approach",
    "jungle-35": "Almost there",
    "jungle-36": "The lost temple",
    "winter.title": "Winter trail",
    "winter.description": "Leave a little light in every footprint.",
    "winter-1": "Snow steps",
    "winter-2": "A different direction",
    "winter-3": "Frozen corners",
    "winter-4": "The long way round",
    "winter-5": "Snowflake",
    "winter-6": "Winter loops",
    "winter-7": "Ice explorer",
    "winter-8": "Twists and turns",
    "winter-9": "Cold logic",
    "winter-10": "Pattern finder",
    "winter-11": "Trail master",
    "winter-12": "Winter wonder",
    "temple.title": "The lost temple",
    "temple.description": "Forty connected chambers. Restore a celestial device with tools, memory and your own routines."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Trash, currently empty",
    "OPEN_TRASH": "Open trash",
    "BLOCK_LABEL_BEGIN_STACK": "Begin stack",
    "WORKSPACE_LABEL_1_STACK": "1 stack of blocks",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 stacks of blocks",
    "ARIA_TYPE_FIELD_NUMBER": "number",
    "ARIA_TYPE_FIELD_DROPDOWN": "dropdown",
    "ARIA_TYPE_FIELD_IMAGE": "image",
    "WORKSPACE_LABEL_PLAIN": "My notebook",
    "FIELD_LABEL_EDIT_PREFIX": "Edit %1",
    "BLOCK_LABEL_HAS_INPUT": "has input",
    "BLOCK_LABEL_HAS_INPUTS": "has inputs",
    "BLOCK_LABEL_HAS_BRANCHES": "has %1 branches",
    "FIELD_LABEL_OPTION_INDEX": "Option %1",
    "INPUT_LABEL_EMPTY": "Empty",
    "BLOCK_LABEL_DISABLED": "disabled",
    "BLOCK_LABEL_COLLAPSED": "collapsed",
    "BLOCK_LABEL_BEGIN_PREFIX": "Begin %1",
    "INPUT_LABEL_END_STATEMENT": "End %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "text",
    "ARIA_TYPE_FIELD_INPUT": "input",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "input name",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "routine name"
  }
}
